// This file is auto-generated, do not make modifications
// tslint:disable:prettier
import React from "react";

export type Props = {
  title?: string;
  version?: any;
  css?: object | string;
} & React.SVGProps<SVGSVGElement>;

const ArrowProfileIcon = ({ title, ...props }: Props) => (
  <svg width={15} height={15} viewBox="0 0 15 15" {...props}>
    {title && <title>{title}</title>}
    <g fill="none" fillRule="evenodd">
      <circle fill="#FFF" cx={7.5} cy={7.5} r={7.5} />
      <path stroke="#424242" strokeWidth={1.5} d="M4 7l3.497 2.738L11 7" />
    </g>
  </svg>
);
export default ArrowProfileIcon;
